<template>
  <div>
    <CContainer>
      <CRow class="justify-content-center mt-4">
        <CCol md="12" class="text-center px-0">
          <h1>
            Teacher Pass
            <HelpCenterButton content-key="teacher_pass_create" />
          </h1>
          <p class="mb-4">(Proxy Pass)</p>
          <CreateTeacherPassForm is-in-view="true" />
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>
<script>
import CreateTeacherPassForm from "@/components/Forms/CreateTeacherPassForm"
import HelpCenterButton from "@/components/HelpCenterButton"

export default {
  name: "TeacherPass",
  components: { CreateTeacherPassForm, HelpCenterButton }
}
</script>
